import { ApiError } from './api-error';

export class NotFoundError extends ApiError {}
